export { default as BackOfficeTabNavigator } from './BackOfficeTabNavigator';
export { default as BackOfficeOrdersTabNavigator } from './BackOfficeOrdersTabNavigator';
export { default as BackOfficePeopleTabNavigator } from './BackOfficePeopleTabNavigator';
